import { Dispatch } from 'redux'

import type { TGetSimChatsQueryParams } from '@homepal/api-contract'

import { getSimChat, getSimChats } from 'redux/api/internal/SimChats'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

/** The reducer's scope guard compares this, not the params object. */
export function simChatsRequestKey(params: TGetSimChatsQueryParams): string {
  return [
    params.customer_id ?? 'all',
    params.rating ?? 'all',
    params.limit ?? 'default',
    params.offset ?? '0'
  ].join('|')
}

function tryGetSimChats(params: TGetSimChatsQueryParams = {}) {
  return (dispatch: Dispatch) => {
    const requestKey = simChatsRequestKey(params)

    dispatch(actions.getAll({ requestKey }))

    getSimChats(params)
      .then((response) => {
        dispatch(
          actions.getAllSuccess({ data: response.data.data, requestKey })
        )
      })
      .catch(() => {
        dispatch(actions.getAllFailed({ requestKey }))
      })
  }
}

function tryGetSimChat(id: string, callback?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getOne({ id }))

    getSimChat(id)
      .then((response) => {
        dispatch(actions.getOneSuccess(response.data.data))

        callback?.()
      })
      .catch(() => {
        dispatch(actions.getOneFailed({ id }))

        callback?.(true)
      })
  }
}

export const useSimChatActions = () => {
  return {
    tryGetSimChat: useThunkActions(tryGetSimChat),
    tryGetSimChats: useThunkActions(tryGetSimChats)
  }
}
